"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('InferenceTracking');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "InferenceTracking" */ './lazyIndex');
});
/**
 * This is the function consumers should call when preparing data to log to inference API
 * via @see logCustomDataLoggerDatapoint or @see logUsage.
 * Note that inference APIs do not care about conversationIds -- they do not help train the
 * inference model and will be discarded! -- so you must first make a call to grab itemIds.
 * To prevent any bias in the data from lazy loading, you will also need to make the activity
 * time call inline. You can just copy: new Date().toISOString()
 */
exports.lazyBuildInferenceDatapoint = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.buildInferenceDatapoint; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-inference-tracking/lib/index.js
// module id = 3827
// module chunks = 62